// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-footer {
  padding-top: 12px;
  padding-bottom: 48px;
  text-align: left;
  font-size: 14px;
  color: #fff;
  background-color: #222;
}
.srprs-footer > .wrapper-inner {
  position: relative;
  margin: 0 auto;
  width: calc(100% - 40px);
  max-width: 1140px;
}
@supports (padding: max(0px)) {
  .srprs-footer {
    padding-left: calc(constant(safe-area-inset-left));
    padding-right: calc(constant(safe-area-inset-right));
  }
}
.srprs-footer hr {
  display: none;
}
.srprs-footer a {
  line-height: 26px;
  color: #fff;
}
.srprs-footer address .tel {
  margin-bottom: 0;
}
.srprs-footer address .availability {
  font-size: 0.9em;
}
.srprs-footer address .availability.is-available {
  color: #badf96;
}
.srprs-footer address .availability.is-unavailable {
  color: #fd4941;
}
.srprs-footer .wrapper-columns {
  margin-bottom: 24px;
}
.srprs-footer .wrapper-footnotes::after {
  clear: both;
  content: "";
  display: table;
}
.srprs-footer .wrapper-footnotes .wrapper-social {
  height: 14px;
  margin-top: 6px;
  float: left;
}
.srprs-footer .wrapper-footnotes .wrapper-social li {
  margin-right: 8px;
  display: inline-block;
  text-align: right;
}
.srprs-footer .wrapper-footnotes .wrapper-social li:last-child {
  margin-right: 0;
}
.srprs-footer .wrapper-footnotes .wrapper-social a {
  line-height: 1em;
}
.srprs-footer .wrapper-footnotes .wrapper-social svg {
  width: 24px;
}
.srprs-footer .wrapper-footnotes .slogan {
  display: none;
}
.srprs-footer .wrapper-footnotes .icons {
  float: right;
  width: 100%;
  margin-bottom: 5px;
}
.srprs-footer .wrapper-footnotes .srprsme-icon > svg {
  float: right;
  height: 38px;
  width: 58px;
}
.srprs-footer .wrapper-footnotes .icons > svg,
.srprs-footer .wrapper-footnotes .icons > a > svg {
  float: right;
  height: 30px;
  width: 30px;
}
.srprs-footer .column {
  display: block;
}
.srprs-footer .column:last-of-type {
  display: none;
}
.srprs-footer .column label {
  position: relative;
  display: block;
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  font-weight: bold;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  text-transform: uppercase;
  cursor: pointer;
}
.srprs-footer .column label:before, .srprs-footer .column label:after {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  content: "";
  position: absolute;
  top: 50%;
  right: 4px;
  background-color: #fff;
  width: 2px;
  height: 7px;
}
.srprs-footer .column label:before {
  transform: translate(3px, -50%) rotate(45deg);
  height: 8px;
  border-top-right-radius: 1px;
  border-top-left-radius: 1px;
}
.srprs-footer .column label:after {
  transform: translate(-2px, -50%) rotate(-45deg);
}
.srprs-footer .column input[type=checkbox],
.srprs-footer .column input[type=radio] {
  display: none;
}
.srprs-footer .column input[type=checkbox]:checked ~ label,
.srprs-footer .column input[type=radio]:checked ~ label {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
}
.srprs-footer .column input[type=checkbox]:checked ~ label:before,
.srprs-footer .column input[type=radio]:checked ~ label:before {
  transform: translate(-2px, 0) rotate(45deg);
}
.srprs-footer .column input[type=checkbox]:checked ~ label:after,
.srprs-footer .column input[type=radio]:checked ~ label:after {
  transform: translate(2px, 0) rotate(-45deg);
}
.srprs-footer .column input[type=checkbox]:checked ~ .collapsible,
.srprs-footer .column input[type=radio]:checked ~ .collapsible {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  max-height: 400px;
  padding-bottom: 24px;
}
.srprs-footer .column .chevron {
  position: relative;
}
.srprs-footer .column .collapsible {
  transition-property: all;
  transition-duration: 0.25s;
  transition-timing-function: ease-out;
  transition-delay: 0s;
  max-height: 0;
  overflow: hidden;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #343434;
}
.srprs-footer .srprs-icon svg path {
  fill: #fff;
}
.srprs-footer-alt {
  color: #313131;
  background-color: #e7e7e7;
  font-weight: 500;
}
.srprs-footer-alt a {
  color: #313131;
}
.srprs-footer-alt .slogan {
  color: #313131;
}
.srprs-footer-alt .srprs-icon svg path,
.srprs-footer-alt .srprsme-icon svg path,
.srprs-footer-alt svg path {
  fill: #313131;
}

@media screen and (min-width: 768px) {
  .srprs-footer {
    padding-top: 30px;
  }
  .srprs-footer::after {
    clear: both;
    content: "";
    display: table;
  }
  .srprs-footer hr {
    display: block;
    background-color: #343434;
    height: 1px;
    width: 100%;
    border: none;
  }
  .srprs-footer .wrapper-columns {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .srprs-footer .wrapper-footnotes .icons > svg,
  .srprs-footer .wrapper-footnotes .srprsme-icon > svg {
    display: none;
  }
  .srprs-footer .wrapper-footnotes .wrapper-social {
    float: right;
  }
  .srprs-footer .wrapper-footnotes .wrapper-social li {
    margin-right: 12px;
  }
  .srprs-footer .wrapper-footnotes .slogan {
    display: inline-block;
    float: left;
    height: 24px;
    margin-top: 6px;
    line-height: 24px;
    color: #9e9e9e;
    font-size: 16px;
  }
  .srprs-footer .column {
    flex: 50%;
  }
  .srprs-footer .column:last-of-type {
    display: block;
    position: relative;
  }
  .srprs-footer .column:last-of-type .icons {
    float: right;
    width: 100%;
    margin-bottom: 20px;
  }
  .srprs-footer .column:last-of-type .icons > a > svg,
  .srprs-footer .column:last-of-type .icons > svg {
    width: 40px;
  }
  .srprs-footer .column:last-of-type > div {
    position: absolute;
    width: 100%;
    bottom: 48px;
  }
  .srprs-footer .column:last-of-type svg {
    float: right;
    width: 72px;
  }
  .srprs-footer .column label {
    pointer-events: none;
  }
  .srprs-footer .column label:before, .srprs-footer .column label:after {
    display: none;
  }
  .srprs-footer .column .collapsible {
    padding-bottom: 48px;
    max-height: none;
    border-bottom: none;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-footer .column {
    flex: 25%;
  }
}
@media screen and (min-width: 1280px) {
  .srprs-footer {
    padding-top: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Footer/Footer.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_wrapper-inner.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_iphonex.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_clearfix.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_transition.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AArMA;EAKI,iBAAA;EACA,oBAAA;EAGA,gBAAA;EAGA,eAAA;EAEF,WAAA;EAEE,sBAAA;AA6LJ;AI9ME;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAIE,iBAAA;AJ6MN;AKrNE;ELEF;IKAM,kDAAA;IACA,oDAAA;ELuNJ;AACF;AAvME;EACE,aAAA;AAyMJ;AAvME;EACE,iBAAA;EACA,WAAA;AAyMJ;AAtMI;EAEI,gBAAA;AAuMR;AApMI;EAEI,gBAAA;AAqMR;AAnMM;EACE,cAAA;AAqMR;AAnMM;EACE,cAAA;AAqMR;AAjME;EAEI,mBAAA;AAkMN;AMhPE;EACE,WAAA;EACA,WAAA;EACA,cAAA;ANkPJ;AAlMI;EACE,YAAA;EAEE,eAAA;EAEF,WAAA;AAkMN;AAjMM;EAEI,iBAAA;EAEF,qBAAA;EAEE,iBAAA;AAgMV;AA9LQ;EAEI,eAAA;AA+LZ;AA3LM;EACE,gBAAA;AA6LR;AA3LM;EACE,WAAA;AA6LR;AA1LI;EACE,aAAA;AA4LN;AA1LI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AA4LN;AA1LI;EACE,YAAA;EACA,YAAA;EACA,WAAA;AA4LN;AA1LI;;EAEE,YAAA;EACA,YAAA;EACA,WAAA;AA4LN;AAzLE;EACE,cAAA;AA2LJ;AAzLI;EACE,aAAA;AA2LN;AAxLI;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EAEE,eAAA;EACA,iBAAA;EACA,2IAAA;EAEF,yBAAA;EACA,eAAA;AAwLN;AAvLM;EOpHF,wBAAA;EACA,0BPqHwB;EOpHxB,oCAAA;EAEE,oBANqD;EP0HnD,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EAEE,sBAAA;EAEF,UAAA;EACA,WAAA;AAwLR;AAtLM;EACE,6CAAA;EACA,WAAA;EAEE,4BAAA;EACA,2BAAA;AAuLV;AApLM;EACE,+CAAA;AAsLR;AAlLI;;EAEE,aAAA;AAoLN;AAlLQ;;EOnJJ,wBAAA;EACA,0BPmJ0B;EOlJ1B,oCAAA;EAEE,oBANqD;AP8U3D;AAtLU;;EACE,2CAAA;AAyLZ;AAvLU;;EACE,2CAAA;AA0LZ;AAtLQ;;EO9JJ,wBAAA;EACA,0BP8J0B;EO7J1B,oCAAA;EAEE,oBANqD;EPmKjD,iBAAA;EAEE,oBAAA;AA0LZ;AApLI;EACE,kBAAA;AAsLN;AAnLI;EO7KA,wBAAA;EACA,0BP6KsB;EO5KtB,oCAAA;EAEE,oBANqD;EPiLrD,aAAA;EACA,gBAAA;EAII,wBAAA;EACA,0BAAA;EACA,4BAAA;AAqLV;AA9KM;EACE,UAAA;AAgLR;AA3KE;EACE,cAAA;EAEE,yBAAA;EAGA,gBAAA;AA0KN;AAxKI;EACE,cAAA;AA0KN;AAxKI;EACE,cAAA;AA0KN;AArKM;;;EACE,aAAA;AAyKR;;AC5XI;ED0NF;IAGI,iBAAA;EAoKJ;EMpYA;IACE,WAAA;IACA,WAAA;IACA,cAAA;ENsYF;EAvKE;IACE,cAAA;IAEE,yBAAA;IAEF,WAAA;IACA,WAAA;IACA,YAAA;EAuKJ;EArKE;IACE,aAAA;IACA,8BAAA;IACA,eAAA;EAuKJ;EApKI;;IAEE,aAAA;EAsKN;EApKI;IACE,YAAA;EAsKN;EArKM;IAEI,kBAAA;EAsKV;EAlKI;IACE,qBAAA;IACA,WAAA;IACA,YAAA;IAEE,eAAA;IAEF,iBAAA;IACA,cAAA;IAEE,eAAA;EAiKR;EA7JE;IACE,SAAA;EA+JJ;EA9JI;IACE,cAAA;IACA,kBAAA;EAgKN;EA/JM;IACE,YAAA;IACA,WAAA;IACA,mBAAA;EAiKR;EAhKQ;;IAEE,WAAA;EAkKV;EA/JM;IACE,kBAAA;IACA,WAAA;IACA,YAAA;EAiKR;EA/JM;IACE,YAAA;IACA,WAAA;EAiKR;EA9JI;IACE,oBAAA;EAgKN;EA/JM;IAEE,aAAA;EAgKR;EA7JI;IAEI,oBAAA;IAEF,gBAAA;IAEE,mBAAA;EA4JR;AACF;AC1cI;EDsTA;IACE,SAAA;EAuJJ;AACF;AC/cI;ED6TF;IAEI,iBAAA;EAoJJ;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n\n.srprs-footer {\n  @include wrapper-inner();\n  @include iphonex();\n\n  padding: {\n    top: 12px;\n    bottom: 48px;\n  }\n  text: {\n    align: left;\n  }\n  font: {\n    size: 14px;\n  }\n  color: color(white);\n  background: {\n    color: color(black);\n  }\n  hr {\n    display: none;\n  }\n  a {\n    line-height: 26px;\n    color: color(white);\n  }\n  address {\n    .tel {\n      margin: {\n        bottom: 0;\n      }\n    }\n    .availability {\n      font: {\n        size: 0.9em;\n      }\n      &.is-available {\n        color: #badf96;\n      }\n      &.is-unavailable {\n        color: #fd4941;\n      }\n    }\n  }\n  .wrapper-columns {\n    margin: {\n      bottom: 24px;\n    }\n  }\n  .wrapper-footnotes {\n    @include clearfix();\n    .wrapper-social {\n      height: 14px;\n      margin: {\n        top: 6px; // h\n      }\n      float: left;\n      li {\n        margin: {\n          right: 8px;\n        }\n        display: inline-block;\n        text: {\n          align: right;\n        }\n        &:last-child {\n          margin: {\n            right: 0;\n          }\n        }\n      }\n      a {\n        line-height: 1em;\n      }\n      svg {\n        width: 24px;\n      }\n    }\n    .slogan {\n      display: none;\n    }\n    .icons {\n      float: right;\n      width: 100%;\n      margin-bottom: 5px;\n    }\n    .srprsme-icon > svg {\n      float: right;\n      height: 38px;\n      width: 58px;\n    }\n    .icons > svg,\n    .icons > a > svg {\n      float: right;\n      height: 30px;\n      width: 30px;\n    }\n  }\n  .column {\n    display: block;\n\n    &:last-of-type {\n      display: none;\n    }\n\n    label {\n      position: relative;\n      display: block;\n      height: 54px;\n      line-height: 54px;\n      font: {\n        size: 14px;\n        weight: bold;\n        family: font(heading);\n      }\n      text-transform: uppercase;\n      cursor: pointer;\n      &:before,\n      &:after {\n        @include transition(0.25s);\n\n        content: '';\n        position: absolute;\n        top: 50%;\n        right: 4px;\n        background: {\n          color: color(white);\n        }\n        width: 2px;\n        height: 7px;\n      }\n      &:before {\n        transform: translate(3px, -50%) rotate(45deg);\n        height: 8px;\n        border: {\n          top-right-radius: 1px;\n          top-left-radius: 1px;\n        }\n      }\n      &:after {\n        transform: translate(-2px, -50%) rotate(-45deg);\n      }\n    }\n\n    input[type='checkbox'],\n    input[type='radio'] {\n      display: none;\n      &:checked {\n        & ~ label {\n          @include transition(0.25s);\n\n          &:before {\n            transform: translate(-2px, 0) rotate(45deg);\n          }\n          &:after {\n            transform: translate(2px, 0) rotate(-45deg);\n          }\n        }\n\n        & ~ .collapsible {\n          @include transition(0.25s);\n\n          max-height: 400px;\n          padding: {\n            bottom: 24px;\n          }\n        }\n      }\n    }\n\n    .chevron {\n      position: relative;\n    }\n\n    .collapsible {\n      @include transition(0.25s);\n      max-height: 0;\n      overflow: hidden;\n\n      border: {\n        bottom: {\n          width: 1px;\n          style: solid;\n          color: #343434;\n        }\n      }\n    }\n  }\n  .srprs-icon {\n    svg {\n      path {\n        fill: color(white);\n      }\n    }\n  }\n\n  &-alt {\n    color: color(dark-text);\n    background: {\n      color: color(grey-light);\n    }\n    font: {\n      weight: 500;\n    }\n    a {\n      color: color(dark-text);\n    }\n    .slogan {\n      color: color(dark-text);\n    }\n    .srprs-icon svg,\n    .srprsme-icon svg,\n    svg {\n      path {\n        fill: color(dark-text);\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-footer {\n    @include clearfix();\n    padding: {\n      top: section(padding-tablet-portrait);\n    }\n    hr {\n      display: block;\n      background: {\n        color: #343434;\n      }\n      height: 1px;\n      width: 100%;\n      border: none;\n    }\n    .wrapper-columns {\n      display: flex;\n      justify-content: space-between;\n      flex-wrap: wrap;\n    }\n    .wrapper-footnotes {\n      .icons > svg,\n      .srprsme-icon > svg {\n        display: none;\n      }\n      .wrapper-social {\n        float: right;\n        li {\n          margin: {\n            right: 12px;\n          }\n        }\n      }\n      .slogan {\n        display: inline-block;\n        float: left;\n        height: 24px;\n        margin: {\n          top: 6px;\n        }\n        line-height: 24px;\n        color: #9e9e9e;\n        font: {\n          size: 16px;\n        }\n      }\n    }\n    .column {\n      flex: 50%;\n      &:last-of-type {\n        display: block;\n        position: relative;\n        .icons {\n          float: right;\n          width: 100%;\n          margin-bottom: 20px;\n          > a > svg,\n          > svg {\n            width: 40px;\n          }\n        }\n        > div {\n          position: absolute;\n          width: 100%;\n          bottom: 48px;\n        }\n        svg {\n          float: right;\n          width: 72px;\n        }\n      }\n      label {\n        pointer-events: none;\n        &:before,\n        &:after {\n          display: none;\n        }\n      }\n      .collapsible {\n        padding: {\n          bottom: 48px;\n        }\n        max-height: none;\n        border: {\n          bottom: none;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-footer {\n    .column {\n      flex: 25%;\n    }\n  }\n}\n\n@include breakpoint(desktop) {\n  .srprs-footer {\n    padding: {\n      top: section(padding-tablet-landscape);\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin wrapper-inner($max-width: '') {\n  > .wrapper-inner {\n    position: relative;\n    margin: 0 auto;\n    width: calc(100% - 40px);\n    @if $max-width != '' {\n      max-width: ($max-width);\n    } @else {\n      max-width: 1140px;\n    }\n  }\n}\n","@mixin iphonex {\n  // reference: https://forum.vuejs.org/t/getting-css-ready-for-iphone-x/25212/5\n  @supports (padding: max(0px)) {\n    padding: {\n      left: calc(constant(safe-area-inset-left));\n      right: calc(constant(safe-area-inset-right));\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin clearfix {\n  &::after {\n    clear: both;\n    content: '';\n    display: table;\n  }\n}\n","@charset \"UTF-8\";\n\n@mixin transition($transition-duration, $transition-delay: 0s) {\n  transition: {\n    property: all;\n    duration: $transition-duration;\n    timing-function: ease-out;\n    @if $transition-delay {\n      delay: $transition-delay;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
